<!-- Root shell: toggles live-chat-mode class when chatMode === 'live' -->
<div class="ai-chatbot-container"
     [class.live-chat-mode]="chatMode === 'live'"
     [class.ai-chatbot-container--minimizing]="isMinimizing">

  <!-- ========== AI AGENT MODE ========== -->
  <ng-container *ngIf="chatMode === 'ai'">
  <!-- AI header: branding, kebab menu, connect live agent, close -->
  <div class="chat-header">
    <div class="header-left">
      <img src="assets/icon/ai-chatbot-icons/Evolve_AI_Agent_Icon.svg" alt="Virtual Assistant" />
      <div class="header-brand">
        <div class="header-title">
          <span class="title-evolve">VIRTUAL</span>
          <div class="title-agent-wrap">
            <span class="title-agent">ASSISTANT</span>
          </div>
        </div>
      </div>
    </div>
    <div class="header-actions">
      <span matTooltipPosition="below" [matTooltip]="isTrackingFlowActive ? 'Finish the tracking flow or use Customer Service below' : 'Chat with a Live Agent'">
        <button class="connect-live-btn" (click)="connectToLiveAgent()" type="button"
          [disabled]="isTrackingFlowActive">
          <img src="assets/icon/ai-chatbot-icons/customer_service.svg" alt="" class="connect-live-icon" />
          <span>Chat with Customer Service</span>
        </button>
      </span>
      <button class="close-btn" (click)="close()" matTooltip="Minimize chat" matTooltipPosition="below" type="button">
        <img src="assets/icon/ai-chatbot-icons/caret-down-white.svg" alt="Minimize chat" class="action-icon action-icon--caret" />
      </button>
    </div>
  </div>
  <!-- AI message list: loops messages[] from API / user input -->
  <ng-container *ngIf="!isCppFlowActive">
  <div class="chat-messages" #messagesContainer>
    <div *ngFor="let message of messages" class="message" [ngClass]="{
           'user-message': message.isUser,
           'ai-message': !message.isUser,
           'welcome-message': !message.isUser && (message.type === 'menu' || message.type === 'tracking-menu' || message.trackingData || message.type === 'error')
         }">
      <!-- [API] Tracking result: shown when message.trackingData is set from askAI() / handleQuickAction() -->
      <ng-container *ngIf="!message.isUser && message.trackingData">

        <!-- No Record Found -->
        <ng-container *ngIf="!message?.trackingData?.status && !message?.trackingData?.shipments?.length">
          <div class="message-top tracking-result-message">
            <div class="message-avatar">
              <span class="ai-avatar">
                <img src="assets/icon/ai-chatbot-icons/agent.svg" alt="AI" />
              </span>
            </div>
            <div class="message-stack tracking-result-stack">
              <div class="tracking-response-bubble">
                <p class="tracking-summary">We couldn’t locate a matching
                  <span>{{ message.trackingData.trackingType || 'order number' }}</span>. Please verify the information and try again.
                </p>
                <!-- <div class="not-found-badge">
                  <span class="not-found-badge-icon delivery-status-icon--accent">
                    <span class="not-found-badge-icon-inner">?</span>
                  </span>
                  <div class="delivery-status-text">
                    <span class="delivery-status-label">NOT FOUND</span>
                    <span class="delivery-status-sub">No delivery information found</span>
                  </div>
                </div> -->
              </div>
            </div>
          </div>
          <span class="message-meta message-meta--with-avatar">
            {{virtualAssitant}} &middot; {{ message.timestamp | date:'shortTime' }}
          </span>
          <div class="tracking-follow-up">
            <div class="tracking-next-divider">HERE'S WHAT YOU CAN DO NEXT</div>

            <button type="button"
                    class="tracking-action-card"
                    [class.tracking-action-card--selected]="selectedTrackingDetail"
                    (click)="trackAnotherOrder()">
              <span class="tracking-action-icon-wrap">
                <img src="assets/icon/ai-chatbot-icons/truck_moving.svg" alt="" class="tracking-action-icon" />
              </span>
              <span class="tracking-action-text">
                <span class="tracking-action-title">Track Another Order</span>
              </span>
              <span class="tracking-action-arrow">
                <img src="assets/icon/ai-chatbot-icons/arrow.svg" alt="" class="arrow-icon" />
              </span>
            </button>

            <p class="tracking-footer-prompt">Do you need anything else?</p>
            <div class="tracking-footer-actions">
              <button class="menu-action-card" (click)="restartConversation()" type="button">
                <span class="menu-action-card-icon-wrap">
                  <img [src]="iconBase + '/main_menu.svg'" alt="" />
                </span>
                <span class="menu-action-card-text">
                  <span class="menu-action-card-title">Main Menu</span>
                  <span class="menu-action-card-subtitle">Go back to virtual assistant.</span>
                </span>
              </button>
              <button class="menu-action-card" (click)="connectToLiveAgent()" type="button">
                <span class="menu-action-card-icon-wrap">
                  <img [src]="iconBase + '/customer_service.svg'" alt="" />
                </span>
                <span class="menu-action-card-text">
                  <span class="menu-action-card-title">Customer Service</span>
                  <span class="menu-action-card-subtitle">Get live help</span>
                </span>
              </button>
            </div>
          </div>
        </ng-container>

        <!-- Valid shipment, but tracking status is expired/unknown/unsupported -->
        <ng-container *ngIf="(message.trackingData.status || message.trackingData.shipments?.length) && isTrackingUnavailable(message.trackingData)">
          <div class="message-top tracking-result-message">
            <div class="message-avatar">
              <span class="ai-avatar">
                <img src="assets/icon/ai-chatbot-icons/agent.svg" alt="AI" />
              </span>
            </div>
            <div class="message-stack tracking-result-stack">
              <div class="tracking-response-bubble">
                <p class="tracking-summary">
                  Shipment tracking information is currently not available. Please contact Customer Service for assistance with this shipment.
                </p>
              </div>
            </div>
          </div>
          <span class="message-meta message-meta--with-avatar">
            {{virtualAssitant}} &middot; {{ message.timestamp | date:'shortTime' }}
          </span>
          <div class="tracking-follow-up">
            <div *ngIf="message.trackingData?.trackingUrl" class="tracking-next-divider">HERE'S WHAT YOU CAN DO NEXT</div>

            <button type="button"
                    *ngIf="message.trackingData?.trackingUrl"
                    class="tracking-action-card"
                    [class.tracking-action-card--selected]="selectedTrackingDetail"
                    (click)="onTrackingDetailSelect(message.trackingData)">
              <span class="tracking-action-icon-wrap">
                <img src="assets/icon/ai-chatbot-icons/truck_moving.svg" alt="" class="tracking-action-icon" />
              </span>
              <span class="tracking-action-text">
                <span class="tracking-action-title">View Full Tracking Details</span>
                <span class="tracking-action-subtitle">See complete shipment history</span>
              </span>
              <span class="tracking-action-arrow" [class.tracking-action-arrow--selected]="selectedTrackingDetail">
                <img src="assets/icon/ai-chatbot-icons/arrow.svg" alt="" class="arrow-icon" />
              </span>
            </button>

            <p class="tracking-footer-prompt">Do you need anything else?</p>
            <div class="tracking-footer-actions">
              <button class="menu-action-card" (click)="restartConversation()" type="button">
                <span class="menu-action-card-icon-wrap">
                  <img [src]="iconBase + '/main_menu.svg'" alt="" />
                </span>
                <span class="menu-action-card-text">
                  <span class="menu-action-card-title">Main Menu</span>
                  <span class="menu-action-card-subtitle">Go back to virtual assistant.</span>
                </span>
              </button>
              <button class="menu-action-card" (click)="connectToLiveAgent()" type="button">
                <span class="menu-action-card-icon-wrap">
                  <img [src]="iconBase + '/customer_service.svg'" alt="" />
                </span>
                <span class="menu-action-card-text">
                  <span class="menu-action-card-title">Customer Service</span>
                  <span class="menu-action-card-subtitle">Get live help</span>
                </span>
              </button>
            </div>
          </div>
        </ng-container>

        <!-- Valid tracking result -->
        <ng-container *ngIf="(message.trackingData.status || message.trackingData.shipments?.length) && !isTrackingUnavailable(message.trackingData) && getTrackingDisplay(message.trackingData.status, message.trackingData.estimatedDelivery) as tracking">
        <div class="message-top tracking-result-message">
          <div class="message-avatar">
            <span class="ai-avatar">
              <img src="assets/icon/ai-chatbot-icons/agent.svg" alt="AI" />
            </span>
          </div>
          <div class="message-stack tracking-result-stack">
            <div class="tracking-response-bubble">
              <p class="tracking-greeting">Good news, {{ userName || 'there' }}!</p>

              <!-- Multiple shipments: one row per shipment instead of a single status card -->
              <ng-container *ngIf="message.trackingData?.shipments?.length as total; else singleShipmentResult">
                <p class="tracking-summary mb-2">
                  Found {{ total }} shipments for {{ message.trackingData.trackingType || 'order number' }}
                  <span class="tracking-highlight">{{ message.trackingData.referenceValue || message.trackingData.orderNumber }}</span>.
                </p>

                <div *ngIf="getStatusBreakdown(message).length" class="status-breakdown">{{ getStatusBreakdown(message).join(' &middot; ') }}</div>

                <div class="shipments-list">
                  <div *ngFor="let shipment of visibleShipments(message)" class="shipment-row"
                       [class.shipment-row--expanded]="isShipmentExpanded(message, shipment.shipmentId)"
                       (click)="toggleShipmentExpansion(message, shipment.shipmentId)">
                    <div class="shipment-row-header">
                      <span class="shipment-doc-icon">
                        <img [src]="iconBase + '/shipment-document.svg'" alt="" />
                      </span>
                      <span class="shipment-row-title">Shipment #{{ shipment.shipmentId }}</span>
                      <span *ngIf="isShipmentStatusSupported(shipment.status)" class="shipment-row-status" [ngClass]="statusClass(shipment.status)">{{ shipment.status }}</span>
                      <span class="shipment-row-chevron" [class.shipment-row-chevron--open]="isShipmentExpanded(message, shipment.shipmentId)">
                        <img [src]="iconBase + '/chevron-down-yellow.svg'" alt="" />
                      </span>
                    </div>

                    <div *ngIf="isShipmentExpanded(message, shipment.shipmentId)" class="shipment-row-details">
                      <button *ngIf="shipment.trackingUrl" class="shipment-track-card" (click)="$event.stopPropagation(); onTrackingDetailSelect({ trackingUrl: shipment.trackingUrl })" type="button">
                        <span class="shipment-track-card__icon">
                          <img src="assets/icon/ai-chatbot-icons/truck_moving.svg" alt="" />
                        </span>
                        <span class="shipment-track-card__label">Track Shipment</span>
                        <span class="shipment-track-card__arrow">
                          <img src="assets/icon/ai-chatbot-icons/arrow.svg" alt="" />
                        </span>
                      </button>
                      <span *ngIf="!shipment.trackingUrl && isShipmentStatusSupported(shipment.status)" class="shipment-row-awaiting">Awaiting Carrier Update</span>
                      <span *ngIf="!shipment.trackingUrl && !isShipmentStatusSupported(shipment.status)" class="shipment-row-awaiting">
                        Shipment tracking information is currently not available. Please contact Customer Service for assistance with this shipment.
                      </span>
                    </div>
                  </div>
                </div>

                <button *ngIf="total - (message.visibleShipmentCount || 6) > 0" class="show-more-btn" (click)="loadMoreShipments(message)" type="button">
                  <span>Show {{ total - (message.visibleShipmentCount || 6) }} more</span>
                  <span class="show-more-btn__icon-wrap">
                    <img src="assets/icon/ai-chatbot-icons/arrow.svg" alt="" class="show-more-btn__icon" />
                  </span>
                </button>
              </ng-container>

              <!-- Single-shipment result: same layout as multi shipment -->
              <ng-template #singleShipmentResult>
              <p class="tracking-summary mb-2">
                Found 1 shipment for {{ message.trackingData.trackingType || 'order number' }}
                <span class="tracking-highlight">{{ message.trackingData.referenceValue || message.trackingData.orderNumber }}</span>.
              </p>

              <div *ngIf="isShipmentStatusSupported(message.trackingData.status)" class="status-breakdown">1 {{ message.trackingData.status | titlecase }}</div>

              <div class="shipments-list">
                <div class="shipment-row shipment-row--expanded shipment-row--static">
                  <div class="shipment-row-header">
                    <span class="shipment-doc-icon">
                      <img [src]="iconBase + '/shipment-document.svg'" alt="" />
                    </span>
                    <span class="shipment-row-title">Shipment #{{ message.trackingData.shipmentNumber || message.trackingData.orderNumber || message.trackingData.referenceValue }}</span>
                    <span *ngIf="isShipmentStatusSupported(message.trackingData.status)" class="shipment-row-status" [ngClass]="statusClass(message.trackingData.status)">{{ message.trackingData.status }}</span>
                  </div>

                  <div class="shipment-row-details">
                    <button *ngIf="message.trackingData.trackingUrl" class="shipment-track-card" (click)="onTrackingDetailSelect(message.trackingData)" type="button">
                      <span class="shipment-track-card__icon">
                        <img src="assets/icon/ai-chatbot-icons/truck_moving.svg" alt="" />
                      </span>
                      <span class="shipment-track-card__label">Track Shipment</span>
                      <span class="shipment-track-card__arrow">
                        <img src="assets/icon/ai-chatbot-icons/arrow.svg" alt="" />
                      </span>
                    </button>
                    <span *ngIf="!message.trackingData.trackingUrl" class="shipment-row-awaiting">Awaiting Carrier Update</span>
                  </div>
                </div>
              </div>
              </ng-template>
            </div>
          </div>
        </div>
        <span class="message-meta message-meta--with-avatar">
          {{virtualAssitant}} &middot; {{ message.timestamp | date:'shortTime' }}
        </span>

        <!-- Tracking follow-up actions: full details link, main menu, customer service -->
        <div class="tracking-follow-up">
          <p class="tracking-footer-prompt">Do you need anything else?</p>
          <div class="tracking-footer-actions">
            <button class="menu-action-card" (click)="restartConversation()" type="button">
              <span class="menu-action-card-icon-wrap">
                <img [src]="iconBase + '/main_menu.svg'" alt="" />
              </span>
              <span class="menu-action-card-text">
                <span class="menu-action-card-title">Main Menu</span>
                  <span class="menu-action-card-subtitle">Go back to virtual assistant.</span>
              </span>
            </button>
            <button class="menu-action-card" (click)="connectToLiveAgent()" type="button">
              <span class="menu-action-card-icon-wrap">
                <img [src]="iconBase + '/customer_service.svg'" alt="" />
              </span>
              <span class="menu-action-card-text">
                <span class="menu-action-card-title">Customer Service</span>
                  <span class="menu-action-card-subtitle">Get live help</span>
              </span>
            </button>
          </div>
        </div>
        </ng-container>
      </ng-container>
      <!-- Welcome menu + tracking sub-menu: message.type === 'menu' | 'tracking-menu' -->
      <ng-container *ngIf="!message.isUser && (message.type === 'menu' || message.type === 'tracking-menu') && !message.trackingData">
        <div class="message-top">
          <div class="message-avatar">
            <span class="ai-avatar">
              <img src="assets/icon/ai-chatbot-icons/agent.svg" alt="AI" />
            </span>
          </div>
          <div class="message-stack">
            <p *ngIf="message.type === 'menu'" class="message-bubble welcome-greeting">
              {{ welcomeGreeting }}
            </p>
            <p *ngIf="message.type === 'tracking-menu' && message.text" class="message-bubble">
              {{ message.text }}
            </p>
          </div>
        </div>
        <span class="message-meta message-meta--with-avatar">
          {{virtualAssitant}} &middot; {{ message.timestamp | date:'shortTime' }}
        </span>
        <div *ngIf="message.actions?.length" class="quick-actions"
          [class.quick-actions--primary]="message.type === 'menu'"
          [class.quick-actions--tracking]="message.type === 'tracking-menu'">
          <div class="quick-actions-label">
            {{ message.type === 'menu' ? 'QUICK ACTIONS' : 'SELECT TRACKING METHOD' }}
          </div>
          <button *ngFor="let action of message.actions" class="quick-action-btn"
            [class.quick-action-btn--tile]="message.type === 'tracking-menu'"
            [disabled]="isTrackingFlowActive && activeTrackingMode !== action.key"
            [class.disabled-action]="action.key === 'create-request' || action.key === 'find-inventory'"
            [class.active-option]="message.type === 'tracking-menu' ? activeTrackingMode === action.key : activePrimaryMenuKey === action.key"
            (click)="handleQuickAction(action)" type="button">
            <span class="action-icon-wrap">
              <img [src]="getActionIcon(action.key)" [alt]="getActionLabel(action)" class="action-icon" />
            </span>
            <span class="action-text">
              <span class="action-label">{{ getActionLabel(action) }}</span>
              <span class="action-subtitle">{{ getActionSubtitle(action.key) }}</span>
            </span>
            <span *ngIf="message.type !== 'tracking-menu'" class="action-arrow"
              [class.arrow-selected]="activePrimaryMenuKey === action.key">
              <img src="assets/icon/ai-chatbot-icons/arrow.svg" alt="" class="arrow-icon" />
            </span>
          </button>
          <div *ngIf="message.type === 'tracking-menu' && !isTrackingFlowActive" class="tracking-hint">
            <span>Tap a tile to get started with your tracking.</span>
          </div>
          <div *ngIf="message.type === 'tracking-menu' && isTrackingFlowActive" class="back-container">
            <button class="back-btn" (click)="resetTrackingFlow()" type="button">Back</button>
          </div>
        </div>
      </ng-container>
      <!-- Standard chat bubbles: user text + AI text replies from API -->
      <ng-container *ngIf="(message.isUser || (message.type !== 'menu' && message.type !== 'tracking-menu')) && !message.trackingData">
        <div class="message-body" [class.message-body--user]="message.isUser" [class.message-body--ai]="!message.isUser">
          <div class="message-row">
            <div class="message-avatar">
              <span *ngIf="!message.isUser" class="ai-avatar">
                <img src="assets/icon/ai-chatbot-icons/agent.svg" alt="AI" />
              </span>
              <span *ngIf="message.isUser" class="user-avatar">
                <img src="assets/icon/ai-chatbot-icons/user.svg" alt="User" />
              </span>
            </div>
            <div class="message-content">
              <p *ngIf="message.text">{{ message.text }}</p>
            </div>
          </div>
          <span class="message-meta"
                [class.message-meta--user]="message.isUser"
                [class.message-meta--with-avatar]="!message.isUser">
            <ng-container *ngIf="message.isUser">{{ userName || 'You' }} &middot; </ng-container>
            <ng-container *ngIf="!message.isUser">{{virtualAssitant}} &middot; </ng-container>
            {{ message.timestamp | date:'shortTime' }}
          </span>
          <div *ngIf="message.actions?.length" class="quick-actions quick-actions--inline">
            <button *ngFor="let action of message.actions" class="quick-action-btn"
              [disabled]="isTrackingFlowActive && activeTrackingMode !== action.key"
              [class.disabled-action]="action.key === 'create-request' || action.key === 'find-inventory'"
              [class.active-option]="activeTrackingMode === action.key" (click)="handleQuickAction(action)"
              type="button">
              <span class="action-icon-wrap">
                <img [src]="getActionIcon(action.key)" [alt]="action.label" class="action-icon" />
              </span>
              <span class="action-text">
                <span class="action-label">{{ action.label }}</span>
                <span class="action-subtitle">{{ getActionSubtitle(action.key) }}</span>
              </span>
              <span class="action-arrow" [class.arrow-selected]="activeTrackingMode === action.key">
                <img src="assets/icon/ai-chatbot-icons/arrow.svg" alt="" class="arrow-icon" />
              </span>
            </button>
          </div>
        </div>
        <div *ngIf="message.type === 'error'" class="tracking-footer-actions">
          <button class="menu-action-card" (click)="restartConversation()" type="button">
            <span class="menu-action-card-icon-wrap">
              <img [src]="iconBase + '/main_menu.svg'" alt="" />
            </span>
            <span class="menu-action-card-text">
              <span class="menu-action-card-title">Main Menu</span>
              <span class="menu-action-card-subtitle">Go back to virtual assistant.</span>
            </span>
          </button>
          <button class="menu-action-card" (click)="connectToLiveAgent()" type="button">
            <span class="menu-action-card-icon-wrap">
              <img [src]="iconBase + '/customer_service.svg'" alt="" />
            </span>
            <span class="menu-action-card-text">
              <span class="menu-action-card-title">Customer Service</span>
              <span class="menu-action-card-subtitle">Get live help</span>
            </span>
          </button>
        </div>
      </ng-container>
    </div>
    <!-- Typing indicator: bound to isTyping while askAI() request is in flight -->
    <div *ngIf="isTyping" class="message ai-message typing-indicator">
      <div class="message-avatar">
        <span class="ai-avatar">
          <img src="assets/icon/ai-chatbot-icons/agent.svg" alt="AI" />
        </span>
      </div>
      <div class="message-content">
        <div class="typing-dots">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </div>
  </div>
  <!-- AI input footer: restart + sendMessage() -> askAI() -->
  <div class="chat-input-container" *ngIf="!(messages.length === 1 && messages[0]?.type === 'menu')">
    <div class="chat-input-row">
      <button type="button" class="home-btn" matTooltip="Reset Conversation" matTooltipPosition="above"
        aria-label="Reset Conversation" (click)="restartConversation()">
        <img [src]="iconBase + '/home.svg'" alt="" class="home-btn__icon" aria-hidden="true" />
      </button>
      <div class="chat-input-wrap">
        <input #messageInput type="text" [(ngModel)]="userInput" (keypress)="onKeyPress($event)"
             [placeholder]="inputPlaceholder" class="chat-input"
          [disabled]="isInputDisabled" />
        <button class="send-btn" (click)="sendMessage()" [disabled]="isSendDisabled" type="button">
          <img src="assets/icon/ai-chatbot-icons/prompt.svg" alt="Send" class="send-icon" />
        </button>
      </div>
    </div>
    <div *ngIf="validationError" class="validation-error">{{ validationError }}</div>
  </div>
  </ng-container>

  <!-- CPP order sub-flow: separate messages + input, shared header above -->
  <app-ai-cpp-chatbot *ngIf="isCppFlowActive" [userDisplayName]="userName" (orderCompleted)="onCppOrderCompleted()" (navigateToTracking)="onCppNavigateToTracking()" (closeChatWindow)="onCppCloseChatWindow()"></app-ai-cpp-chatbot>
  </ng-container>

  <!-- ========== LIVE AGENT MODE ========== -->
  <ng-container *ngIf="chatMode === 'live'">
    <!-- Live header: online (Sarah) or offline layout based on isLiveAgentOnline -->
    <div class="live-chat-header"
         [class.live-chat-header--online]="isLiveAgentOnline"
         [class.live-chat-header--offline]="!isLiveAgentOnline">
      <ng-container *ngIf="isLiveAgentOnline">
        <button class="back-to-agent-btn" (click)="toggleConfirm($event, 'back')" type="button">
          <img [src]="iconBase + '/Evolve_agent_chat.svg'" alt="" class="back-to-agent-icon" />
          <span>Back to Vitual Assitant</span>
        </button>
        <div class="kebab-menu-wrapper">
          <button class="kebab-menu-btn" (click)="toggleKebabMenu($event)" matTooltip="More options" matTooltipPosition="below" type="button">
            <img [src]="iconBase + '/more-horizontal.svg'" alt="More options" class="action-icon" />
          </button>
          <div class="kebab-dropdown" *ngIf="isKebabMenuOpen">
            <button class="kebab-dropdown-item" (click)="emailSFTranscript()" type="button">
              <img [src]="iconBase + '/email.svg'" alt="Email" class="dropdown-icon" />
              <span>Email Transcript</span>
            </button>
          </div>
        </div>
        <div class="live-header-right">
          <div class="live-header-brand-block">
            <div class="live-agent-badge">
              <img [src]="iconBase + '/customer_service.svg'" alt="" class="live-badge-icon" />
              <span class="live-badge-text">LIVE</span>
            </div>
            <div class="live-header-brand">
              <div class="live-header-title">
                <span class="title-evolve">EVOLVE</span>
                <span class="title-chat">CHAT</span>
              </div>
              <div class="live-agent-info">
                <span class="live-agent-name">{{ liveAgent.name }}</span>
                <span class="live-agent-role">{{ liveAgent.role }}</span>
              </div>
            </div>
          </div>
          <div class="close-menu-wrapper">
            <button class="close-btn" (click)="toggleConfirm($event, 'close')" matTooltip="End Conversation" matTooltipPosition="below" type="button">
              <img [src]="iconBase + '/close-white.svg'" alt="Close" class="action-icon" />
            </button>
            <div class="close-confirm-dropdown" *ngIf="pendingConfirm" (click)="$event.stopPropagation()">
              <p class="close-confirm-dropdown__message">Do you want to End the Conversation?</p>
              <div class="close-confirm-dropdown__actions">
                <button type="button" class="close-confirm-dropdown__btn close-confirm-dropdown__btn--no" (click)="cancelConfirm()">No</button>
                <button type="button" class="close-confirm-dropdown__btn close-confirm-dropdown__btn--yes" (click)="confirmEndConversation()">Yes</button>
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="!isLiveAgentOnline">
        <div class="live-header-left">
          <div class="live-agent-badge live-agent-badge--offline">
            <img [src]="iconBase + '/customer_service.svg'" alt="" class="live-badge-icon" />
          </div>
          <div class="live-header-brand">
            <div class="live-header-title">
              <span class="title-evolve">EVOLVE</span>
              <span class="title-chat">CHAT</span>
            </div>
          </div>
        </div>
        <div class="live-header-right">
          <button class="back-to-agent-btn back-to-agent-btn--header" (click)="toggleConfirm($event, 'back')" type="button">
            <img [src]="iconBase + '/Evolve_agent_chat.svg'" alt="" class="back-to-agent-icon" />
            <span>Back to Virtual Assistant</span>
          </button>
          <div class="close-menu-wrapper">
            <button class="close-btn" (click)="toggleConfirm($event, 'close')" matTooltip="End Conversation" matTooltipPosition="below" type="button">
              <img [src]="iconBase + '/close-white.svg'" alt="Close" class="action-icon" />
            </button>
            <div class="close-confirm-dropdown" *ngIf="pendingConfirm" (click)="$event.stopPropagation()">
              <p class="close-confirm-dropdown__message">Do you want to End the Conversation?</p>
              <div class="close-confirm-dropdown__actions">
                <button type="button" class="close-confirm-dropdown__btn close-confirm-dropdown__btn--no" (click)="cancelConfirm()">No</button>
                <button type="button" class="close-confirm-dropdown__btn close-confirm-dropdown__btn--yes" (click)="confirmEndConversation()">Yes</button>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>

    <!-- Status strip: connected / connecting / offline -->
    <div class="live-status-bar"
         [class.live-status-bar--connected]="isLiveAgentOnline"
         [class.live-status-bar--waiting]="!isLiveAgentOnline && !isOfflineStateVisible"
         [class.live-status-bar--offline]="isOfflineStateVisible">
      <ng-container *ngIf="isLiveAgentOnline">Connected to Live Agent</ng-container>
      <ng-container *ngIf="!isLiveAgentOnline && !isOfflineStateVisible">Please wait while we are connecting to Customer Service...</ng-container>
      <ng-container *ngIf="isOfflineStateVisible">Customer Service is currently offline. Please try again later.</ng-container>
    </div>

    <!-- Offline body: empty state with a single return-to-menu action -->
    <div class="live-chat-offline" *ngIf="isOfflineStateVisible">
      <div class="offline-state">
        <span class="offline-state__icon">
          <img [src]="iconBase + '/customer_service.svg'" alt="" />
        </span>
        <h3 class="offline-state__title">Customer Service is Offline</h3>
        <p class="offline-state__text">
          {{liveAgentOfflineMessage}}
        </p>
        <button class="offline-state__action" (click)="backToEvolveAgent()" type="button">
          <img [src]="iconBase + '/main_menu.svg'" alt="" />
          <span>Back to Main Menu</span>
        </button>
      </div>
    </div>

    <!-- Live chat thread: greeting + liveUserMessages from sendMessage() -->
    <div class="live-chat-messages" #liveMessagesContainer *ngIf="isLiveAgentOnline">
      <div class="live-message live-message--agent">
        <div class="live-message-avatar live-message-avatar--agent">
          <img [src]="iconBase + '/customer_service.svg'" alt="" class="live-avatar-icon" />
        </div>
        <div class="live-message-body">
          <div class="live-message-bubble">
            <p>Hi {{ userName || 'there' }}! I'm {{ liveAgent.shortName }}, your support specialist. How can I help you today?</p>
          </div>
          <span class="live-message-meta">{{ liveAgent.shortName }} &middot; {{ liveAgent.connectedtimestamp | date:'shortTime' }}</span>
        </div>
      </div>

        <!--<div class="live-message live-message--agent live-typing-indicator">
        <div class="live-message-avatar">
          <img src="assets/icon/ai-chatbot-icons/user.svg" alt="" />
        </div>
        <div class="live-message-body">
          <div class="live-message-bubble live-typing-bubble">
            <div class="typing-dots">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
          <span class="live-message-meta live-typing-meta">{{ liveAgent.shortName }} {{ liveLabels.typing }}</span>
        </div>
      </div>-->

      <ng-container *ngFor="let message of liveUserMessages">
        <div *ngIf="message.role === 'User'" class="live-message live-message--user">
          <div class="live-message-body">
            <div class="live-message-bubble">
              <p>{{ message.text }}</p>
            </div>
            <span class="live-message-meta">{{ userName || 'You' }} &middot; {{ message.timestamp | date:'shortTime' }}</span>
          </div>
          <div class="live-message-avatar">
            <img [src]="iconBase + '/live-avatar.svg'" alt="" class="live-avatar-icon" />
          </div>
        </div>

        <div *ngIf="message.role === 'Agent'" class="live-message live-message--agent">
          <div class="live-message-avatar live-message-avatar--agent">
            <img [src]="iconBase + '/customer_service.svg'" alt="" class="live-avatar-icon" />
          </div>
          <div class="live-message-body">
            <div class="live-message-bubble">
              <p>{{ message.text }}</p>
            </div>
            <span class="live-message-meta">{{ liveAgent.shortName }} &middot; {{ message.timestamp | date:'shortTime' }}</span>
          </div>
        </div>
      </ng-container>
    </div>

    <!-- Live input footer: shared userInput + sendMessage() -->
    <div class="chat-input-container" *ngIf="isLiveAgentOnline">
      <div class="chat-input-wrap">
        <input type="text" [(ngModel)]="userInput" (keypress)="onKeyPress($event)"
               placeholder="Type your message..." class="chat-input" />
        <button class="send-btn" (click)="sendMessage()" [disabled]="!userInput.trim()" type="button">
          <img src="assets/icon/ai-chatbot-icons/prompt.svg" alt="Send" class="send-icon" />
        </button>
      </div>
    </div>
  </ng-container>
</div>
